.header {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.header .brand {
  display: none;
}

.link {
  background-color: #f8f9fa;
  color: #505050;
  padding: 0.25rem 0.5rem !important;
  font-size: 11px;
}
.link a, .link span {
  color: #505050;
}
.link .innerLink {
  display: flex;
  flex-flow: column nowrap;
}
.link .innerLink .icon {
  flex: 1 auto;
  margin-right: none;
}
.link .innerLink .text {
  flex: 1 auto;
  font-size: 10px;
  text-align: center;
}
.link:hover {
  background-color: rgb(91.4215686275%, 92.6470588235%, 93.8725490196%);
}
.link.selected {
  color: rgb(1.3725490196%, 1.3725490196%, 1.3725490196%);
  background-color: rgb(85.5882352941%, 87.6470588235%, 89.7058823529%);
  border-radius: 4px;
}
.link.selected a, .link.selected span {
  color: rgb(1.3725490196%, 1.3725490196%, 1.3725490196%);
}
.link button {
  padding: 0;
  background-color: #f8f9fa;
}
.link button:hover {
  background-color: rgb(91.4215686275%, 92.6470588235%, 93.8725490196%);
}
.link.dark {
  background-color: var(--bs-dark-rgb);
  color: #b0b0b0;
}
.link.dark button {
  background-color: #343a40;
}
.link.dark button:hover {
  background-color: rgb(24.8749154834%, 27.7450980392%, 30.615280595%);
}
.link.dark:hover {
  background-color: rgb(24.8749154834%, 27.7450980392%, 30.615280595%);
}
.link.dark.selected {
  color: rgb(99.0196078431%, 99.0196078431%, 99.0196078431%);
  background-color: rgb(29.3576741041%, 32.7450980392%, 36.1325219743%);
  border-radius: 0;
}
.link.dark.selected a, .link.dark.selected span {
  color: rgb(99.0196078431%, 99.0196078431%, 99.0196078431%);
}
.link.dark a, .link.dark span {
  color: #b0b0b0;
}

.link:global(.dropdown-menu):hover {
  background-color: #f8f9fa;
}

.link.dark:global(.dropdown-menu):hover {
  background-color: #343a40;
}

@media (min-width: 550px) {
  .header .brand {
    display: block;
  }
  .link {
    padding: 0.5rem 1rem !important;
    font-size: 10px;
  }
  .link a {
    padding: 0;
  }
  .link .innerLink {
    flex-flow: row nowrap;
    align-items: center;
  }
  .link .innerLink .icon {
    margin-right: 6px;
  }
  .link .innerLink .text {
    font-size: 10px;
    text-align: center;
  }
}
.theme {
  margin-left: 8px;
}

.login {
  margin-left: 8px;
}

.vial {
  margin-left: 8px;
  color: #f06020;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */